module.exports = __webpack_public_path__ + "static/dimaduchet_3-5ff7b80115aae0f4c5cad38f0b021c79.png";